import React, { useContext, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { LS_ACCESS_TOKEN_KEY, LS_AUTHORITY_KEY, LS_TERMS_AGREED_KEY, LS_UI_ELEMENTS_CONFIG_KEY, LS_USER_ONBOARD_KEY, USER_ROLE } from "../../core/constants/common";
import { COMPLETED_TXT, ONBOARD_TXT, SUPPLIER_DETAILS_TXT } from "../../core/service/CommonService";
import PartnerService from "../../core/service/PartnerService";
import LoginService from "../../core/service/login-service";
import { UserContext } from "../../App";
import PermissionUtils from "../../core/utilities/PermissisonUtils";
import { hasGoalsKpiNavAccess } from "../SubscriberSupplierAdmin/GoalsAndKpi/utils/goalsAndKpiNavAccess";
import { buildHierarchyPermissions } from "../SubscriberSupplierAdmin/GoalsAndKpi/utils/hierarchyPermissions";

const AppLander = ({ t }) => {
  const navigate = useNavigate();
  const { setUserDetails } = useContext(UserContext);

  useEffect(() => {
    const pathname =  window.location.pathname;
    const accessToken = localStorage.getItem(LS_ACCESS_TOKEN_KEY);
    if (!accessToken) return;

    if (pathname?.length > 0 &&  pathname !== '/esg') return;

    LoginService.checkAuthority().then(res => {
      const responseData = res.data.data;
      if (res.status !== 200) return;

      setUserDetails(responseData);
      localStorage.setItem(LS_AUTHORITY_KEY, JSON.stringify(responseData));
      localStorage.setItem(LS_TERMS_AGREED_KEY, responseData?.profile?.user?.termsAgreed ?? true);
     // if (responseData.roles.indexOf(USER_ROLE.SUPER_ADMIN) > -1) {
      if (PermissionUtils.isSuperAdmin(responseData.roles)) {
        navigate("/admin/");
      } else if (PermissionUtils.isConsultant(responseData.roles)) {
        navigate("/consultant/switch/");
      } else {
        if (responseData && responseData.profile.company) {
          profileCompletion(responseData.profile.company.id);
        } else {
          profileCompletion(0);
        }
      }
      fetchUIElementsConfig(responseData?.profile?.user);
    }).catch((error) => {
    });
  }, []);

  const profileCompletion = async (companyId) => {
    LoginService.profileComplete(companyId)
      .then((response) => {
        if (response.status === 200) {
          localStorage.setItem(
            LS_USER_ONBOARD_KEY,
            JSON.stringify(response.data)
          );
          const lsDat = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
          if (lsDat.roles.indexOf(USER_ROLE.SUPER_ADMIN) > -1) {
            navigate("/admin/");
          } else if (response?.data?.pendingInvitations?.length > 0) {
              navigate("/company_admin/pending_invitations");
            } else {
              const nextStep = response.data.nextStep;
              // TEMPORARY: same Goals & KPI nav check as the sidebar. Land on Goals & KPI dashboard. Revisit soon.
              const companyLanding = hasGoalsKpiNavAccess(
                buildHierarchyPermissions(Array.isArray(lsDat?.roles) ? lsDat.roles : [])
              )
                ? "/company_admin/goals_kpi/dashboard"
                : "/company_admin/";
              switch (nextStep) {
                case null:
                case COMPLETED_TXT:
                  navigate(companyLanding);
                  break;
                case ONBOARD_TXT:
                  navigate(
                    "/company_admin/company_onboard/" + response.data.key
                  );
                  break;
                case SUPPLIER_DETAILS_TXT:
                  navigate(
                    "/company_admin/supplier_details_onboard/" +
                    response.data.connectedCompany.companyId +
                    "/" +
                    response.data.connectedCompany.supplierDetails.id
                  );
                  break;
                default:
                  navigate(companyLanding);
                  break;
              }
            }
          }
      })
      .catch((error) => {
      });
  };

  const fetchUIElementsConfig = (userData) => {
    if (!userData.partnerId) {
      localStorage.setItem(LS_UI_ELEMENTS_CONFIG_KEY, null);
      return;
    }    
    PartnerService.getPartnerSpecificUIConfig(userData.partnerId).then(res =>{
      localStorage.setItem(LS_UI_ELEMENTS_CONFIG_KEY, null);
      if (res.status !== 200) return;

      localStorage.setItem(LS_UI_ELEMENTS_CONFIG_KEY, res.data ? JSON.stringify(res.data) : null);
    }).catch(err => {
      localStorage.setItem(LS_UI_ELEMENTS_CONFIG_KEY, null);
     });
  };

  return (
    <></>
  );
};

export default withTranslation()(AppLander);
